import React from 'react'
import AsyncSelect from 'react-select/lib/Async'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { emphasize } from '@material-ui/core/styles/colorManipulator'

import {defaultConfig} from "../../../../config"

import axios from 'axios'

const styles = theme => ({
  input: {
    display: 'flex',
    padding: 0,
    marginTop: '12px'
  },
  valueContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    fontSize: 16,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
})

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  )
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          ref: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
    />
  )
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  )
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>
}

const components = {
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  ValueContainer,
}

let timeout = null

class ArticleInput extends React.Component {


  state = {
    searchValue: '',
    single: null
  }

  handleChange = (value) => {
    this.setState({
      single: value,
    })
  }

  loadArticles = (searchValue, callback) => {
    this.setState({
      searchValue: searchValue,
    })

    if(searchValue === '') searchValue = 'a'

    clearTimeout(timeout)

    // Make a new timeout set to go off in 500ms
    timeout = setTimeout(function () {
      axios.get(defaultConfig.url + "/artikelen/"+searchValue,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('login_token'),
            Accept: 'application/json'
          }
        })
        .then((response) => {

          callback(response.data.articles.map(a => ({
            value: a.naam,
            label: a.naam,
          })))
        })
        .catch((err) => {

        })
    }, 500)
  }

  render() {
    const { classes } = this.props;
    const val = {value: this.props.value, label: this.props.value}

    return (
      <div className={classes.root}>
          <AsyncSelect
            classes={classes}
            components={components}
            value={val}
            onChange={(value) => this.props.handleNormalSubjectsValueChange(value.value, this.props.idx)}
            loadOptions={this.loadArticles}
          />
      </div>
    )
  }
}

export default withStyles(styles)(ArticleInput)



// WEBPACK FOOTER //
// ./src/js/components/pages/newAppointment/autocompletes/ArticleInput.js